module.exports = __webpack_public_path__ + "static/kamila-jaszynska-medinvest-ad265a0637f8f847999d35ed67934158.jpg";